<SocialTags
	pageTitle="Membresía activada"
	pageDesc="¡Muchas gracias!, tu membresía ha sido activada, a partir de ahora podrás disfrutar de todas las sesiones que D-NS Studio preparó para tí."
></SocialTags>

<style src="./style.scss">

</style>

<main id="dnsPageSignup" class="mbsc-grid d-ns-page checkout-success-page">
	<nav>
		<MainMenu
			on:menuTapped={togglePages}
      selectedItem='signup'
			path={router.path}
		></MainMenu>
	</nav>

  {#if paymentInfo}
  <section class="mbsc-row">
    <header class="mbsc-col-12">
      <h1>Membresía activada</h1>
      <p>¡Muchas gracias!, tu membresía ha sido activada, a partir de ahora podrás disfrutar de todas las sesiones que D-NS Studio preparó para tí.</p>
    </header>

    <div class="mbsc-card payment-info mbsc-col-12 mbsc-col-md-6">
      <div class="mbsc-card-header">
        <h2 class="mbsc-card-title">Detalles de tu pago</h2>
        <h3 class="mbsc-card-subtitle">Esta información estará disponible también desde <a href="/my-account/">tu Cuenta</a></h3>
      </div>
      <div class="mbsc-card-content">
        <p>
          <strong>Total: </strong>${paymentInfo.amount_total / 100} MXN IVA incluido
        </p>
        <p>
          <strong>Subscripción: </strong>{paymentInfo.description}
        </p>
        <p>
          <strong>Duración: </strong>{paymentInfo.recurrence === 'month' ? 'Mensual' : 'Anual'}
        </p>
      </div>
      <div class="mbsc-card-footer mbsc-align-right"><a href="/contacto/">Solicitar factura</a></div>
    </div>
    
  </section>
  {/if}

	<footer class="mbsc-row">
		<nav class="mbsc-col-12">
			<FooterMenu></FooterMenu>
		</nav>
		<CopyrightFooter></CopyrightFooter>
	</footer>
</main>

<script>
import { onMount, afterUpdate } from 'svelte';

import SocialTags from '@Components/SocialTags/index.svelte';
import MainMenu from '@Components/MainMenu/index.svelte';

import Content from '@Pages/Contacto/content.svelte';

import FooterMenu from '@Components/FooterMenu/index.svelte';
import CopyrightFooter from '@Components/CopyrightFooter/index.svelte';

import { AWSAuth, Navigation, Utils, Stripe, Payment, AWSAnalytics } from '@Services';

export let router = null;

const DEBUG = document.location.protocol === 'http:' ? true : false;

let paymentInfo = null;

let togglePages = (event) => {
  Navigation.goTo(event.detail.item);
};

afterUpdate(() => {
  
});

onMount(async () =>{
  console.info('App ' + DEBUG + '::' + router.path);
  
  AWSAuth.getUser().then(member => {
    if (typeof member === 'string') {
      Navigation.goTo('home');
      return;
    }
    Stripe.getCheckoutItems(null, router.params.sessionId).then((response) => {
      paymentInfo = response;
      const data = {
        paymentID: router.params.sessionId,
        customerID: response.customer,
        recurrence: response.recurrence,
        amount: response.amount_total / 100,
      };
      _confirmationMessage(data);
	  }).catch(error => {
      console.error(error);
      mobiscroll.alert({
        title: 'Gracias por tu compra',
        message: 'Recibirás un correo cuando hayamos activado tu membresía anual. Para cualquier duda o aclaración puedes visitar nuestra página de contacto.',
        callback: () => {
          Navigation.goTo('home');
        },
      });
    });
  });
	
  mobiscroll.settings = {
		theme: 'd-ns',
		themeVariant: 'light',
		lang: 'es'
	};

  mobiscroll.page('.checkout-success-page', {});
  
  mobiscroll.card('.payment-info', {
    theme: 'd-ns'
  });
	
	Utils.scrollToTop();
});
</script>
